import { useLocalStorage } from "@vueuse/core";

const useChatTheme = () => {
  const chatTheme = useLocalStorage<"classic" | "colorful">(
    "chatThemeV2",
    "classic"
  );

  return {
    chatTheme,
  };
};

const { chatTheme } = useChatTheme();

export default chatTheme;
